import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { Table } from "./Table";
import useToggle from "../../hooks/useToggle";
import { ILead } from "../../models/BaseModel";

export interface IOpenForm {
    open: boolean,
    singleData: ILead
}

export const Customer = ({ hasPermission }: { hasPermission: (pageName: string, featureName?: string) => boolean }) => {

    const [modal, setModal] = useState({ singleData: {}, open: false } as IOpenForm);
    const [reload, reloadData] = useToggle();
    const toast = useRef<any>(null);
    
    return (
        <>
            <Table hasPermission={hasPermission} setModal={setModal} toast={toast} reload={reload} reloadData={reloadData}></Table>
            <Toast ref={toast} />
        </>
    );
}
